/**
 * Component to display Projects
 */
//  Genric imports
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

//  Motif imports 
import MotifTextLink from '@ey-xd/motif-react/TextLink';

/**
 * Internal imports
 */
import './Projects.scss';

import NoProjects from "../noProjects/NoProjects";
import Utils from "../../../utils/Utils";

import { setActiveProject } from "../../../redux/userSlice";

export default function Projects() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { projects } = useSelector(state => state.user);
    const utils = new Utils();

    const navToProject = () => {
        navigate('/home/projectDetails');
    }

    const handleProjectNameClick = async (project) => {
        dispatch(setActiveProject({
            activeProject: project
        }));
        navToProject();
    }

    return (
        (() => {
            if (projects && projects.length === 0) {
                return <NoProjects />
            } else if (projects && projects.length !== 0) {
                return projects.map((project, index) => {
                    return (
                        <MotifTextLink
                            href="#"
                            className={index !== 0 ? "project-div" : "project-div no-border"}
                            key={project.project_UUID}
                            tabIndex="0"
                            onClick={() => handleProjectNameClick(project)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") handleProjectNameClick(project);
                            }}
                        >
                            <div className="project-inner-div">
                                <div>
                                    <div className="project-name">{project.projectName}</div>
                                    <span className="project-date"> {"Created on: " + utils.formatDateString(project.createTS, "Mmm DD, YYYY")}</span>
                                </div>
                            </div>
                        </MotifTextLink>
                    )
                })
            }
        })()
    )
}
